// お知らせ関連の定数

// Markdownエディタの一行当たりの文字数
export const ANNOUNCE_MARKDOWN_LINE_LENGTH = 80;

